module.exports = __webpack_public_path__ + "static/media/logo.85d40236.svg";